import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * @url /approvalmanagement, /usermanagement, /sitemanagement, /messagemanagement, /menumanagement, /checksheetmanagement, /econsultmanagement,/communitymanagement, /infomanagement, /energySolutionManagement
 * @CONST CONST.URL_APPROVALMANAGEMENT, CONST.URL_USERMANAGEMENT, CONST.URL_SITEMANAGEMENT, CONST.URL_MESSAGEMANAGEMENT, CONST.URL_MENUMANAGEMENT,CONST.URL_CHECKSHEETMANAGEMENT, CONST.URL_ECONSULTMANAGEMENT,CONST.URL_COMMUNITYMANAGEMENT, CONST.URL_INFOMANAGEMENT,CONST.URL_ENERGYSOLUTIONMANAGEMENT
 * @menu Managemnet
 * @mapping 승인 관리 화면, 사용자 관리 화면, 사업장 관리 화면, 메시지 관리 화면, 메뉴 관리 화면, Check Sheet 관리 화면, 이메일 상담 관리 화면,커뮤니티 관리 화면, 공지사항 관리 화면, 에너지솔루션 관리 화면
 */
import { useCallback, useEffect, useState } from "react";
// recoil
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
// component
// ex-module
import CommonPopup from "@components/common/popup/CommonPopup";
import ManagementPops from "@components/common/popup/pops/ManagementPops";
import Logout from "@components/login/Logout";
import DashBoardHeader from "@layout/header/dashBoard/DashBoardHeader";
import MyAccount from "@layout/header/dashBoard/MyAccount";
import { checkTypeState, curAdminTreeState, curMonitoringTreeState, curSchduleTreeState, mainState, noneUrl, } from "@recoil/assessmentState";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { langState } from "../recoil/langState";
import { checkSheetState, contactusState, loadingBoxState, menuListState, parentCode, spgState, urlState, } from "../recoil/menuState";
import * as CONST from "../utils/Const";
function ManagementLayout() {
    const location = useLocation();
    const navigate = useNavigate();
    // recoil
    const [urlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    const [menuCodeRecoil, setMenuCodeRecoil] = useRecoilState(parentCode);
    const resetRecoilTreeData = useResetRecoilState(curSchduleTreeState);
    const resetRecoilData = useResetRecoilState(curMonitoringTreeState);
    const resetRecoilAdminData = useResetRecoilState(curAdminTreeState);
    const resetCheck = useResetRecoilState(checkTypeState);
    const resetRecoilState = useResetRecoilState(mainState);
    const resetReContactusState = useResetRecoilState(contactusState);
    const resetCheckSheet = useResetRecoilState(checkSheetState);
    const resetSpgs = useResetRecoilState(spgState);
    const menuRecoilList = useRecoilValue(menuListState);
    const recoilNoneUrlInfo = useRecoilValue(noneUrl);
    const langs = useRecoilValue(langState); // recoil langState
    const loading = useRecoilValue(loadingBoxState);
    const [menuList, setMenuList] = useState(null);
    useEffect(() => {
        setRecoilUrlInfo(location.pathname);
    }, [location.pathname]);
    // 특정 화면에서 url로 menu 정보 추출하기 위함
    useEffect(() => {
        let tmenuList = menuRecoilList;
        if (tmenuList.length <= 0) {
        }
        let curMenu = null;
        tmenuList
            .filter((smenu) => smenu.url === urlInfo)
            .map((smenu) => {
            if (smenu.url === urlInfo)
                curMenu = smenu;
        });
        setMenuCodeRecoil(curMenu && curMenu.parentCode);
        const tempMenu = [];
        tmenuList
            .filter((smenu) => curMenu && smenu.parentCode === curMenu.parentCode)
            .map((smenu) => {
            tempMenu.push({
                menuName: smenu.menuName,
                menuUrl: smenu.url,
            });
        });
        setMenuList(tmenuList);
        if (!recoilNoneUrlInfo) {
            //초기화
            resetRecoilData(); //모니터링
            resetRecoilTreeData(); //오늘의 점검
            resetRecoilAdminData(); //운영관리
            resetCheck();
            resetRecoilState();
            resetReContactusState();
        }
        if (menuRecoilList != null && menuRecoilList.length != 0 && !menuRecoilList.some((menu) => menu.url === urlInfo)) {
            navigate(CONST.URL_NOT_FOUND, { replace: true });
        }
    }, [urlInfo, menuRecoilList]);
    useEffect(() => {
        const handleClick = (e) => {
            const targetElement = e.target;
            const isSelect = targetElement.classList.contains("select") || targetElement.closest(".select");
            if (isSelect) {
                return;
            }
            const allSelectBoxElements = document.querySelectorAll(".select");
            allSelectBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("active");
            });
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, []);
    const [popData, setPopData] = useState([]);
    const handleOpenPop = useCallback((id, body) => {
        setPopData((prev) => [...prev, { id, body }]);
    }, []);
    function TabClick(url) {
        setRecoilUrlInfo(url);
        navigate(url);
        if (url == "/spgmanagement") {
            window.location.reload();
        }
        if (urlInfo !== url) {
            // 초기화
            resetCheckSheet();
            resetSpgs();
        }
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ id: "wrap", className: `no-responsive ${langs == CONST.STR_LANG_ENG ? "lang-eng" : ""}` }, { children: [_jsx(DashBoardHeader, {}), menuList && urlInfo && menuRecoilList.length != 0 && (_jsxs(_Fragment, { children: [_jsx("main", Object.assign({ className: "container" }, { children: _jsx("section", Object.assign({ className: "content w100p" }, { children: _jsxs("article", Object.assign({ className: "box" }, { children: [_jsx("ul", Object.assign({ className: "tab__line" }, { children: menuList
                                                    .filter((smenu) => smenu.parentCode == menuCodeRecoil)
                                                    .map((smeun, idx) => (_jsx("li", Object.assign({ className: `${urlInfo == smeun.url ? "on" : ""}`, onClick: () => TabClick(smeun.url) }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: smeun.menuName })) }), "management_" + idx.toString()))) })), _jsx(Outlet, { context: { handleOpenPop } })] })) })) })), _jsx(CommonPopup, {})] }))] })), _jsx(Logout, { path: CONST.URL_LOGIN }), _jsx(MyAccount, {}), _jsx(ManagementPops, { popData: popData }), _jsx("div", { className: "dimm" }), loading && _jsx(Loading, {})] }));
}
function Loading(props) {
    const loadingBox = useRecoilValue(loadingBoxState);
    const isAuth = props.isAuth;
    return (_jsx("div", Object.assign({ className: !isAuth || loadingBox ? "loading" : "" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB85C\uB529\uC911" })) })));
}
export default ManagementLayout;
